<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
@if (compareProducts$ | async; as compareProducts) { @if (compareProductSKUs$ | async; as compareProductSKUs) { @if
(compareProducts?.length && compareProductSKUs?.length) {
<div class="filter-list-group">
  @if (compareProducts?.length > 1) {
  <div>
    <p class="filter-item">
      {{ 'dias.filter.compare.items.count.text' | translate : { '0': compareProducts?.length } }}
    </p>
  </div>
  } @else {
  <p class="filter-item">
    {{ 'dias.filter.compare.one.item.text' | translate : { '0': compareProducts?.length } }}
  </p>
  } @for (product of compareProducts; track product) {
  <div class="filter-item">
    <a
      class="btn-tool"
      [title]="'product.compare.remove.link' | translate"
      (click)="openDeleteConfirmationDialog(product.sku, deleteDialog)"
    >
      <fa-icon [icon]="['fas', 'trash-alt']" /> <span>{{ product.name }}</span>
    </a>
  </div>
  }
  <div class="compare-detail-link d-flex justify-content-between mt-2">
    <a class="compare-status item-count-container filter-item" routerLink="/compare" rel="nofollow"
      ><span>{{ 'product.compare.link' | translate }}</span></a
    >
    <a
      class="compare-status item-count-container filter-item"
      (click)="openClearAllConfirmationDialog(clearAll)"
      rel="nofollow"
      ><span>{{ 'dias.product.compare.clear.all.link' | translate }}</span></a
    >
  </div>
</div>
} @else {
<p class="filter-item" data-testing-id="emptyList">{{ 'product.compare.no_product_selected.message' | translate }}</p>
} } @else {
<p class="filter-item" data-testing-id="emptyList">{{ 'product.compare.no_product_selected.message' | translate }}</p>
} } @else {
<p class="filter-item" data-testing-id="emptyList">{{ 'product.compare.no_product_selected.message' | translate }}</p>
}
<ish-modal-dialog
  #deleteDialog
  [options]="{
    confirmText: 'dias.filter.compare.product.delete.ok.button.text' | translate,
    rejectText: 'account.cancel.button.label' | translate,
    titleText: 'undefined'
  }"
  (confirmed)="removeFromCompare($event)"
>
  {{ 'dias.filter.compare.product.delete.do_you_really.text' | translate }}
</ish-modal-dialog>
<ish-modal-dialog
  #clearAll
  [options]="{
    confirmText: 'dias.filter.compare.product.delete.ok.button.text' | translate,
    rejectText: 'account.cancel.button.label' | translate,
    titleText: 'undefined'
  }"
  (confirmed)="clearAllFromCompare()"
>
  {{ 'dias.filter.compare.product.delete.all.products.do_you_really.text' | translate }}
</ish-modal-dialog>
